import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import { Button, TextField, InputAdornment } from '@material-ui/core';
import Swal from 'sweetalert2'


import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';


import { decodeHTMLEntities } from '../../../../Functions/utils';

import { roles, toastTimerValue } from '../../../../Shared/utils';
import { update } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { multiSelectStrings } from '../../../../Functions/utils';
import { useReportingContext } from '../../../../Context/Reporting/Provider';

import '../../../SweetAlert.css'

export default function UpdateAccount({users, setUsers, selectedUser, setSelectedUser}) {
  const { t } = useTranslation();
  const [{user}] = useAppContext();
  const [{pickers}] = useReportingContext();
  // const locations = pickers.locations.all.map(loc => { loc.label = loc.label.replace('\u2001', ''); return loc; });
  const tmpLocations = JSON.parse(JSON.stringify(pickers.locations.all));
  const locations = tmpLocations.map(loc => { loc.label = loc.label.replace(/\u2001/g, ''); return loc; });

  const [loading, setLoading] = useState(false);
  const [newUser, setNewUser] = useState({...selectedUser, // if loc.group doesn't exist -> not a location
    oldEmail: selectedUser.email,
    locations: pickers.locations.all.filter(loc => loc.group && selectedUser.locations.includes(loc.value))
  });


  const handleEditUser = (e, user) => {
    e.preventDefault();
    setLoading(true);
 
    // Set group to NULL for SoftThinks Admins
    user.groupId = !Number(user.groupId) ? null : user.groupId;

    // Only set new contact email if changed
    user.contactEmailActivated = user.contactEmail ? true : false;
    if (user.contactEmail === selectedUser.contactEmail) user.contactEmail = null;

    update({type: 'user', user}).then(res => {
      setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.accounts.errors.' + res, {email: user.email})), {type: 'error'});

        // return Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title: t('admin.accounts.errors.' + res, {email: user.email}),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }

      const newUsers = users.slice(); // .slice() creates a new array
      for (const [index, row] of newUsers.entries()) {
        if (row.id === res.user.id) {
          newUsers[index] = {...res.user, role: t('admin.accounts.types.' + res.user.roleId)}; break;
        }
      }
      
      // update default accounts sorting in case of username change
      setUsers(newUsers.sort((a, b) => a.email.localeCompare(b.email)));
        
      setSelectedUser(null);
      toast(decodeHTMLEntities(t('admin.accounts.update.success', {email: user.email})), {type: 'success'});

      // return Swal.fire({
      //   toast: true,
      //   icon: 'success',
      //   title: t('admin.accounts.update.success', {email: user.email}),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    });
  };


  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleEditUser(e, newUser)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1 title={selectedUser.email}>{t('admin.accounts.update.title', {email: selectedUser.email})}</h1>
            <div>
              <select
                value={newUser.roleId}
                className="singleSelect"
                title={t('admin.accounts.columns.role')}
                onChange={e => {
                  const roleId = Number(e.target.value);
                  const groupId = roleId <= roles.stAdmin ? '' : newUser.groupId;
                  const locations = roleId !== roles.user ? [] : newUser.locations;
                  setNewUser({...newUser, roleId, groupId, locations});
                }}
              >
                <option value="2">{t('admin.accounts.types.' + roles.user)}</option>
                <option value="1">{t('admin.accounts.types.' + roles.admin)}</option>
                {user.roleId <= roles.stAdmin && <option value="0">{t('admin.accounts.types.' + roles.stAdmin)}</option>}
                {user.roleId <= roles.dashboardSuperAdmin && <option value="-1">{t('admin.accounts.types.' + roles.dashboardSuperAdmin)}</option>}
              </select>
            </div>
          </div>

          <div className="prompt__content">
            <div className="flexRow">
              <div>
                <p className="sidebar__label">{t('admin.accounts.columns.group')}</p>
                <select
                  className="singleSelect"
                  value={newUser.groupId ?? '0'}
                  disabled={newUser.roleId <= roles.stAdmin}
                  onChange={e => setNewUser({...newUser, groupId: Number(e.target.value) || null, locations: []})} // Replace "no group" by null
                >
                  <option value="0" hidden>{t('admin.accounts.update.no_group')}</option>
                  {pickers.groups.map(group => <option key={group.value} value={group.value}>{group.label}</option>)}
                </select>
              </div>

              <div className={'sidebar__select' + (newUser.roleId !== roles.user ? ' disabled' : '')}>
                <p className="sidebar__label">{t('sidebar.filters.locations')}</p>
                <MultiSelect
                  value={newUser.locations}
                  onChange={locations => setNewUser({...newUser, locations})}
                  options={locations.filter(loc => loc.group === newUser.groupId)}
                  disabled={!Number(newUser.groupId) || newUser.roleId !== roles.user}
                  ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
                  overrideStrings={{...multiSelectStrings(t), allItemsAreSelected: newUser.locations.map(loc => loc.label).join(', ')}}
                  valueRenderer={(items) => {
                    const values = items.map(loc => loc.label).join(', ');
                    return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t).selectSomeItems;
                  }}
                />
              </div>
            </div>

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">account_circle</span>
                </InputAdornment>
              }}
              required
              name="no-username"
              autoComplete="off"
              variant="outlined"
              value={newUser.email}
              label={t('admin.accounts.columns.email')}
              onChange={e => setNewUser({...newUser, email: e.target.value})}
            />

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">email</span>
                </InputAdornment>
              }}
              name="no-email"
              autoComplete="off"
              variant="outlined"
              value={newUser.contactEmail ?? ''}
              label={t('admin.accounts.columns.contact_email')}
              onChange={e => setNewUser({...newUser, contactEmail: e.target.value})}
            />

            <div className="flexRow">
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>
                }}
                type='password'
                variant="outlined"
                label={t('reset.field1')}
                value={newUser.password ?? ''}
                onChange={e => setNewUser({...newUser, password: e.target.value})}
                placeholder={newUser.passCheck ? '' : t('admin.accounts.update.leave_blank')}
              />

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>
                }}
                type='password'
                variant="outlined"
                label={t('reset.field2')}
                value={newUser.passCheck ?? ''}
                onChange={e => setNewUser({...newUser, passCheck: e.target.value})}
                placeholder={newUser.password ? '' : t('admin.accounts.update.leave_blank')}
              />
            </div>
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedUser(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.save')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
